<template>
  <v-container fluid class="sales-report-list mt-3">
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              loading-text="Loading... Please wait"
              class="sales-reports-table"
              show-select
              single-select
              item-key="_id"
              sort-by="report"
              :footer-props="footer"
              :headers="header_reports"
              :items="data_reports"

              :items-per-page="itemPerPage">
              <template v-slot:item.reportname="{ item }">
                <p class="two-line"><a class="primaryConst--text" v-on:click="viewItem(item)">{{ item.reportname }}</a></p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-file-find-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'GLLedgerList',
  data() {
    return {
      data_reports: [
        {reportname:'Sales Report by Item', name: 'SalesReportByItem'},
        {reportname:'Sales Report by Location', name: 'SalesReportByLocation'},
        {reportname:'Sales Report by Channel', name: 'SalesReportByChannel'},
        {reportname:'Sales Report by Rep', name: 'SalesReportByRep'},
        {reportname:'Sales Summary by Location', name: 'SalesSummaryByLocation'},
        {reportname:'Sales Accounts Receivables', name: 'SalesReportReceivables'},
      ],
      header_reports: [
        { text: 'Report Name', value: 'reportname' },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  methods: {
    viewItem(item) {
      this.$router.push({ name: item.name })
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
